import { Component, OnInit } from '@angular/core';
import { FormService } from '../../services/form.service';

@Component( {
	selector: 'app-background',
	templateUrl: './background.component.html',
	styleUrls: ['./background.component.scss']
} )
export class BackgroundComponent implements OnInit {

	constructor( public formService: FormService ) {
	}

	ngOnInit(): void {

	}
}
